import React from "react"

const ArrowDownGreen = () => {
  return (
    <svg
      width="17"
      height="24"
      viewBox="0 0 17 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9257 16.9301L9.29037 23.6706C8.8976 24.0696 8.28306 24.1062 7.8496 23.7801L7.7254 23.6715L1.07514 16.931C0.642287 16.4922 0.641524 15.7801 1.07343 15.3405C1.46608 14.9408 2.08114 14.9038 2.51493 15.23L2.63923 15.3387L7.39696 20.1625L7.39598 1.12465C7.39598 0.555285 7.81251 0.0847341 8.35293 0.0102634L8.50317 0C9.06369 4.90026e-08 9.52693 0.423098 9.60024 0.972042L9.61035 1.12465L9.61133 20.1655L14.3599 15.3396C14.753 14.9403 15.3681 14.904 15.8015 15.2307L15.9257 15.3396C16.3188 15.7388 16.3545 16.3636 16.0329 16.8039L15.9257 16.9301L9.29037 23.6706L15.9257 16.9301Z"
        fill="#11AB68"
      />
    </svg>
  )
}

export default ArrowDownGreen
